export default __webpack_public_path__ + "media/images/realise-5ae8a1fc999c60e6d7fb66e0f28f2e8b.png";